import React from 'react'
import { MuiGrid, MuiTable, MuiTableContainer, MuiTypography } from '../../ui/MaterialUIComponents';
import OrderListItemComponent from './OrderListItemComponent'
import OrderHeaderComponent from './OrderHeaderComponent'
import theme from '../../../assests/theme'
export default function OrderComponent(props) {
    return (
        <MuiGrid container direction='row' xs={12} style={{ marginTop: '75px' }} alignItems='center' justify='center'>
            {!props.fetchOrderHistoryInFailed ?
                props.orderHistory.length > 0 ?

                    <MuiGrid xs={10}>
                        <MuiGrid container item justify="flex-start" style={{ paddingBottom: 10 }}>
                            <MuiTypography align="left" variant={theme.typographyStyles.H4} color='primary' gutterBottom>
                                {"Order History - " + props.schoolName}
                            </MuiTypography>
                        </MuiGrid>
                        <MuiTableContainer>
                            <MuiTable aria-label="simple table" className={props.table} >
                                <OrderHeaderComponent {...props}></OrderHeaderComponent>
                                <OrderListItemComponent {...props}></OrderListItemComponent>
                            </MuiTable>
                        </MuiTableContainer>
                    </MuiGrid > :
                    <MuiGrid container direction='row' xs={12} style={{ height: "90vh" }} alignItems='center' justify='center'>
                        <MuiGrid xs={10}>
                            <MuiTypography variant={theme.typographyStyles.BODY1}>
                                {props.i18n.orderHistory.orderHistoryNotFound}
                            </MuiTypography>
                        </MuiGrid>
                    </MuiGrid > :
                <MuiGrid container direction='row' xs={12} style={{ height: "90vh" }} alignItems='center' justify='center'>
                    <MuiGrid xs={10}>
                        <MuiTypography variant={theme.typographyStyles.BODY1}>
                            {props.i18n.orderHistory.getOrderHistoryFailed}
                        </MuiTypography>
                    </MuiGrid ></MuiGrid>
            }
        </MuiGrid>

    )

}


